/*
 * 工单数据--投入物料TOP10排名--投入物料明细
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import ScGridTable from "@/components/display/table/gridTableCore";
import { queryFaultTicketDetail } from "@/fetch/fetchApi";

class Material extends Component {
  state = {
    tableConfig: null,
  };

  componentWillMount() {
    const modalParam = this.context.store.getState().modalInfo.param;
    this.setState({
      tableConfig: {
        tableKey: "materialTable",
        tableColumns: [
          {
            name: "工单编号",
            key: "ticketId",
            colType: "textCol",
            align: "center",
          },
          {
            name: "场站名称",
            key: "stationName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "设备编号",
            key: "targetId",
            colType: "textCol",
            align: "center",
          },
          {
            name: "工单时间",
            key: "ticketCreateTime",
            colType: "textCol",
            align: "center",
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
          ...modalParam,
        },
        dataApi: queryFaultTicketDetail,
        autoRefresh: true, // 设置为true 直接加载grid数据
      },
    });
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  render() {
    return <ScGridTable config={this.state.tableConfig} />;
  }
}

export default Material;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/detail/material.js